import { render, staticRenderFns } from "./FacturationList.vue?vue&type=template&id=f990d380&scoped=true"
import script from "./FacturationList.vue?vue&type=script&lang=js"
export * from "./FacturationList.vue?vue&type=script&lang=js"
import style0 from "./FacturationList.vue?vue&type=style&index=0&id=f990d380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f990d380",
  null
  
)

export default component.exports